var indentation_default = {
  "indentZero": "YVYxG",
  "indentOne": "rBzgs",
  "indentTwo": "tiZeG",
  "indentThree": "dqWF7",
  "indentFour": "pnL1y",
  "indentFive": "In6XY",
  "indentSix": "uHTzl"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
